import React from 'react';
import './index.less';
import classNames from 'classnames';
import { Upload } from 'antd';
import ABSList from '../../ABSList';
import ABSMessage from '../../ABSMessage';
import ABSIcon from '../../ABSIcon';
import { IABSUploadListProps } from '../interface';
import ABSLoading from '../../ABSLoading';

export default class List extends React.Component<IABSUploadListProps, any> {
  static defaultProps = {
    iconText: '上传报价',
    placeholder: '您上传的报价信息将在此区域显示',
    accept: '.csv, .xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    action: '',
    withCredentials: false,
    fileList: []
  };

  constructor(props: any) {
    super(props);
    this.state = {
      fileList: [],
      contentData: []
    };
  }

  renderUpload() {
    const { iconText = '', placeholder } = this.props;
    return (
      <>
        <div className="abs-upload-list-plus">
          <ABSIcon isAnt={true} type="plus" />
          <div className="ant-upload-text">{iconText}</div>
        </div>
        <div className="abs-upload-list-placeholder">{placeholder}</div>
      </>
    );
  }

  renderList() {
    const { fileList, contentData } = this.state;
    const [file] = fileList;
    const { columnsData } = this.props;
    const loading = contentData && contentData.length > 0 ? false : true;
    if (loading) {
      return <ABSLoading />;
    }
    return <ABSList columnsData={columnsData} contentData={contentData} bordered={true} loading={loading} onRemove={() => this.onRemove(file)} />;
  }

  render() {
    const { fileList } = this.state;
    const { className, accept, withCredentials, action } = this.props;
    const lengthFlag = fileList.length >= 1 ? false : true;
    const clazz = classNames('abs-upload-list', {
      [`${className}`]: true,
      'abs-upload-list-remove': lengthFlag
    });
    return (
      <div className={clazz}>
        <Upload
          listType="picture-card"
          action={action}
          beforeUpload={this.onBeforeUpload}
          fileList={fileList}
          accept={accept}
          onChange={this.onChange}
          onRemove={this.onRemove}
          openFileDialogOnClick={lengthFlag}
          withCredentials={withCredentials}
        >
          {lengthFlag ? this.renderUpload() : this.renderList()}
        </Upload>
      </div>
    );
  }

  onBeforeUpload = (file, fileList) => {
    const { name } = file;
    const allFileExt = '.xls|.xlsx';
    // 把路径中的所有字母全部转换为小写
    const extName = name.substring(name.lastIndexOf('.')).toLowerCase();
    if (allFileExt.indexOf(extName) < 0) {
      const errMsg = '该文件类型不允许上传，请上传 ' + allFileExt + ' 类型的文件，当前文件类型为' + extName;
      ABSMessage.error(errMsg);
      return false;
    }
    const { updateFile } = this.props;
    if (updateFile) {
      updateFile(file)
        .then(contentData => {
          if (contentData || contentData.length > 0) {
            this.setState({ contentData });
          }
        })
        .catch(() => this.setState({ contentData: [], fileList: [] }));
    }
    this.setState({ fileList });
    return false;
  };

  onChange = responses => null;

  onRemove = file => {
    this.setState({
      fileList: [],
      contentData: []
    });
    const { onRemove } = this.props;
    if (onRemove) {
      onRemove(file);
    }
  };

  onRefresh = () => {
    this.setState({ fileList: [] });
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSUpload/List/index.tsx